import API from "../api";

const getSetting = async () => {
  const { ok, data, message } = await API.get("/setting");
  if (!ok) throw new Error(message);
  return data;
};

export { getSetting };
